export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/logo.15b696cf.svg","height":51,"width":200,"blurWidth":0,"blurHeight":0};